// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file purchase_invoice/common.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { InventoryLineItem } from "../inventory/common_pb.js";
import { SupplierMetadata } from "../suppliers/common_pb.js";

/**
 * @generated from enum com.neulink.pharmacy.PaymentMethod
 */
export enum PaymentMethod {
  /**
   * @generated from enum value: PAYMENT_METHOD_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Cash payment
   *
   * @generated from enum value: PAYMENT_METHOD_CASH = 1;
   */
  CASH = 1,

  /**
   * Credit card payment
   *
   * @generated from enum value: PAYMENT_METHOD_CREDIT_CARD = 2;
   */
  CREDIT_CARD = 2,

  /**
   * Bank transfer payment
   *
   * @generated from enum value: PAYMENT_METHOD_BANK_TRANSFER = 3;
   */
  BANK_TRANSFER = 3,

  /**
   * Mobile payment (e.g., Apple Pay, Google Pay)
   *
   * @generated from enum value: PAYMENT_METHOD_MOBILE_PAYMENT = 4;
   */
  MOBILE_PAYMENT = 4,

  /**
   * Cheque payment
   *
   * @generated from enum value: PAYMENT_METHOD_CHEQUE = 5;
   */
  CHEQUE = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(PaymentMethod)
proto3.util.setEnumType(PaymentMethod, "com.neulink.pharmacy.PaymentMethod", [
  { no: 0, name: "PAYMENT_METHOD_UNSPECIFIED" },
  { no: 1, name: "PAYMENT_METHOD_CASH" },
  { no: 2, name: "PAYMENT_METHOD_CREDIT_CARD" },
  { no: 3, name: "PAYMENT_METHOD_BANK_TRANSFER" },
  { no: 4, name: "PAYMENT_METHOD_MOBILE_PAYMENT" },
  { no: 5, name: "PAYMENT_METHOD_CHEQUE" },
]);

/**
 * @generated from enum com.neulink.pharmacy.PaymentType
 */
export enum PaymentType {
  /**
   * @generated from enum value: PAYMENT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Instant payment
   *
   * @generated from enum value: PAYMENT_TYPE_INSTANT = 1;
   */
  INSTANT = 1,

  /**
   * Credit payment
   *
   * @generated from enum value: PAYMENT_TYPE_CREDIT = 2;
   */
  CREDIT = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(PaymentType)
proto3.util.setEnumType(PaymentType, "com.neulink.pharmacy.PaymentType", [
  { no: 0, name: "PAYMENT_TYPE_UNSPECIFIED" },
  { no: 1, name: "PAYMENT_TYPE_INSTANT" },
  { no: 2, name: "PAYMENT_TYPE_CREDIT" },
]);

/**
 * 'CASH', 'BANK_TRANSFER', 'CHEQUE', 'CREDIT_NOTE_ADJUSTMENT'
 *
 * @generated from enum com.neulink.pharmacy.SupplierPaymentMethod
 */
export enum SupplierPaymentMethod {
  /**
   * @generated from enum value: SUPPLIER_PAYMENT_METHOD_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Cash payment
   *
   * @generated from enum value: SUPPLIER_PAYMENT_METHOD_CASH = 1;
   */
  CASH = 1,

  /**
   * Bank transfer payment
   *
   * @generated from enum value: SUPPLIER_PAYMENT_METHOD_BANK_TRANSFER = 2;
   */
  BANK_TRANSFER = 2,

  /**
   * Cheque payment
   *
   * @generated from enum value: SUPPLIER_PAYMENT_METHOD_CHEQUE = 3;
   */
  CHEQUE = 3,

  /**
   * Credit note adjustment
   *
   * @generated from enum value: SUPPLIER_PAYMENT_METHOD_CREDIT_NOTE_ADJUSTMENT = 4;
   */
  CREDIT_NOTE_ADJUSTMENT = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(SupplierPaymentMethod)
proto3.util.setEnumType(SupplierPaymentMethod, "com.neulink.pharmacy.SupplierPaymentMethod", [
  { no: 0, name: "SUPPLIER_PAYMENT_METHOD_UNSPECIFIED" },
  { no: 1, name: "SUPPLIER_PAYMENT_METHOD_CASH" },
  { no: 2, name: "SUPPLIER_PAYMENT_METHOD_BANK_TRANSFER" },
  { no: 3, name: "SUPPLIER_PAYMENT_METHOD_CHEQUE" },
  { no: 4, name: "SUPPLIER_PAYMENT_METHOD_CREDIT_NOTE_ADJUSTMENT" },
]);

/**
 * @generated from message com.neulink.pharmacy.PurchaseInvoice
 */
export class PurchaseInvoice extends Message<PurchaseInvoice> {
  /**
   * Unique identifier for the purchase invoice
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * ID of the supplier
   *
   * @generated from field: string supplier_id = 2;
   */
  supplierId = "";

  /**
   * Unique invoice number
   *
   * @generated from field: string invoice_number = 3;
   */
  invoiceNumber = "";

  /**
   * Date of the invoice
   *
   * @generated from field: google.protobuf.Timestamp invoice_date = 4;
   */
  invoiceDate?: Timestamp;

  /**
   * Due date for payment
   *
   * @generated from field: google.protobuf.Timestamp delivery_date = 5;
   */
  deliveryDate?: Timestamp;

  /**
   * List of inventory items included in the purchase invoice
   *
   * @generated from field: repeated com.neulink.pharmacy.InventoryLineItem items = 6;
   */
  items: InventoryLineItem[] = [];

  /**
   * Payment method used for the purchase invoice
   *
   * @generated from field: com.neulink.pharmacy.PaymentMethod payment_method = 7;
   */
  paymentMethod = PaymentMethod.UNSPECIFIED;

  /**
   * Type of payment (e.g., FULL, PARTIAL)
   *
   * @generated from field: com.neulink.pharmacy.PaymentType payment_type = 8;
   */
  paymentType = PaymentType.UNSPECIFIED;

  /**
   * Goods Receipt Note number associated with the purchase invoice
   *
   * @generated from field: string grn_number = 9;
   */
  grnNumber = "";

  /**
   * ID of the purchase order associated with this invoice
   *
   * @generated from field: string purchase_order_id = 10;
   */
  purchaseOrderId = "";

  /**
   * ID of the user who created the invoice
   *
   * @generated from field: string created_by = 11;
   */
  createdBy = "";

  /**
   * Timestamp when the invoice was created
   *
   * @generated from field: google.protobuf.Timestamp created_at = 12;
   */
  createdAt?: Timestamp;

  /**
   * Total number of items in the invoice
   *
   * @generated from field: int32 total_items = 13;
   */
  totalItems = 0;

  /**
   * Total amount of the invoice
   *
   * @generated from field: float total_amount = 14;
   */
  totalAmount = 0;

  /**
   * Due date for payment
   *
   * @generated from field: google.protobuf.Timestamp due_date = 15;
   */
  dueDate?: Timestamp;

  /**
   * Status of the invoice (e.g., PAID, UNPAID, PARTIALLY_PAID)
   *
   * @generated from field: string status = 16;
   */
  status = "";

  /**
   * Name of the supplier
   *
   * @generated from field: string supplier_name = 17;
   */
  supplierName = "";

  /**
   * Purchase order number associated with the invoice
   *
   * @generated from field: string purchase_order_number = 18;
   */
  purchaseOrderNumber = "";

  /**
   * Indicates if the invoice has been paid
   *
   * @generated from field: bool is_paid = 19;
   */
  isPaid = false;

  /**
   * Metadata about the supplier
   *
   * @generated from field: com.neulink.pharmacy.SupplierMetadata supplier_metadata = 20;
   */
  supplierMetadata?: SupplierMetadata;

  /**
   * ID of the stock point where the invoice is processed
   *
   * @generated from field: string stock_point_id = 21;
   */
  stockPointId = "";

  /**
   * Name of the stock point where the invoice is
   *
   * @generated from field: string stock_point_name = 22;
   */
  stockPointName = "";

  constructor(data?: PartialMessage<PurchaseInvoice>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.PurchaseInvoice";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "supplier_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "invoice_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "invoice_date", kind: "message", T: Timestamp },
    { no: 5, name: "delivery_date", kind: "message", T: Timestamp },
    { no: 6, name: "items", kind: "message", T: InventoryLineItem, repeated: true },
    { no: 7, name: "payment_method", kind: "enum", T: proto3.getEnumType(PaymentMethod) },
    { no: 8, name: "payment_type", kind: "enum", T: proto3.getEnumType(PaymentType) },
    { no: 9, name: "grn_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "purchase_order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "created_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "created_at", kind: "message", T: Timestamp },
    { no: 13, name: "total_items", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 14, name: "total_amount", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 15, name: "due_date", kind: "message", T: Timestamp },
    { no: 16, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "supplier_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "purchase_order_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 19, name: "is_paid", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 20, name: "supplier_metadata", kind: "message", T: SupplierMetadata },
    { no: 21, name: "stock_point_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 22, name: "stock_point_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PurchaseInvoice {
    return new PurchaseInvoice().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PurchaseInvoice {
    return new PurchaseInvoice().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PurchaseInvoice {
    return new PurchaseInvoice().fromJsonString(jsonString, options);
  }

  static equals(a: PurchaseInvoice | PlainMessage<PurchaseInvoice> | undefined, b: PurchaseInvoice | PlainMessage<PurchaseInvoice> | undefined): boolean {
    return proto3.util.equals(PurchaseInvoice, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.PaymentAllocation
 */
export class PaymentAllocation extends Message<PaymentAllocation> {
  /**
   * ID of the invoice to which this payment is allocated
   *
   * @generated from field: string invoice_id = 1;
   */
  invoiceId = "";

  /**
   * Amount allocated to the invoice
   *
   * @generated from field: float amount = 2;
   */
  amount = 0;

  /**
   * ID of the credit note associated with this allocation, if any
   *
   * @generated from field: string credit_note_id = 3;
   */
  creditNoteId = "";

  constructor(data?: PartialMessage<PaymentAllocation>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.PaymentAllocation";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "invoice_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "amount", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "credit_note_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PaymentAllocation {
    return new PaymentAllocation().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PaymentAllocation {
    return new PaymentAllocation().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PaymentAllocation {
    return new PaymentAllocation().fromJsonString(jsonString, options);
  }

  static equals(a: PaymentAllocation | PlainMessage<PaymentAllocation> | undefined, b: PaymentAllocation | PlainMessage<PaymentAllocation> | undefined): boolean {
    return proto3.util.equals(PaymentAllocation, a, b);
  }
}

